export const EXTRACTS_URI_SURVEY_ANSWERS_REQUEST =
	"EXTRACTS_URI_SURVEY_ANSWERS_REQUEST"
export const EXTRACTS_URI_SURVEY_ANSWERS_RECEIVE =
	"EXTRACTS_URI_SURVEY_ANSWERS_RECEIVE"
export const EXTRACTS_URI_SURVEY_ANSWERS_FAILURE =
	"EXTRACTS_URI_SURVEY_ANSWERS_FAILURE"
